import React from "react";
import LegalDocument from "./LegalDocument";
// Single source of truth: edit the JSON, not this file or
// server/public/privacypolicy.html (generated by scripts/buildLegalHtml.js).
import privacy from "../data/legal/privacyPolicy.json";

function PrivacyPolicy() {
  return <LegalDocument doc={privacy} className="privacy-policy-container" />;
}

export default PrivacyPolicy;
